console.time("AppReady");
import {
	EventDispatcher,
	DomUtil
} from "cartovista";
import '@meq/cartovista-extend/dist/cartovista-extend.css';
import { CartovistaExtend, BbGraphs, MasterBtnThemeSetList, Constat } from "@meq/cartovista-extend";
import {loadData, createLayers, initZoomLayeringLayers} from "./ServerDataHandlers";
import MethodologieAnim from "./MethodologieAnim";
import { Modal } from 'bootstrap';

class App extends EventDispatcher {
	constructor(cartovista) {
		super();
		this.cartovista = cartovista;
		window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
		window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._onServerLayersLoaded, this);
		loadData();
		
    }

    _onCartoVistaMapLoaded() {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
		window.cartovista.resizeRightVerticalSplitter(365);
        createLayers();
        initZoomLayeringLayers();
        if (!DomUtil.isResponsiveUI()) {
			window.cartovista.getUIController(this._map).findInstance("dataView-selectedFeatures")._activateOnSelectionChanged = false;
		} else{
			$("#MethodologieAnim_btn").remove();
		}
		this._$legendViewElement = $(window.cartovista.getUIController(this._map).findInstance("legendView").element);
        
        this._loadCustomModules();
    }

    _onServerLayersLoaded() {
        console.timeEnd("AppReady");
        $("#preloader").remove();
		new BbGraphs();
		new MasterBtnThemeSetList("2018");
        this._map.activeThemeSet = this._map.getThemeSet("Freq_GEO09E01_CS_FRA_STA_GEN_1");
		this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
		new Modal('#IntroModal').show();
    }

    //inclure les modules custom
    _loadCustomModules() {
		new Constat();
		new MethodologieAnim();
    }

    _onThemeSetChanged() {
		if (!DomUtil.isResponsiveUI()) {
			if (this._map.activeThemeSet && this._map.activeThemeSet.id.indexOf("Provincial") > -1) {
				this.activeBottomSidebarGroup = window.cartovista.getUIController(this._map).getActiveToggledItem("bottomSidebarGroup") ? window.cartovista.getUIController(this._map).getActiveToggledItem("bottomSidebarGroup").associatedContainer : null;
				this.activeBottombarGroup = window.cartovista.getUIController(this._map).getActiveToggledItem("bottombarGroup") ? window.cartovista.getUIController(this._map).getActiveToggledItem("bottombarGroup").associatedContainer : null;
				this.activeTopSidebarGroup = window.cartovista.getUIController(this._map).getActiveToggledItem("topSidebarGroup") ? window.cartovista.getUIController(this._map).getActiveToggledItem("topSidebarGroup").associatedContainer : null;
				if(this.activeBottomSidebarGroup) this.activeBottomSidebarGroup.deactivate();
				if(this.activeBottombarGroup) this.activeBottombarGroup.deactivate();
				window.cartovista.getUIController(this._map).findInstance("Constat_panel").activate();
			} else {
				if(this.activeBottomSidebarGroup) this.activeBottomSidebarGroup.activate();
				if(this.activeBottombarGroup) this.activeBottombarGroup.activate();
				if(this.activeTopSidebarGroup) this.activeTopSidebarGroup.activate();
				this.activeBottomSidebarGroup = null;
				this.activeBottombarGroup = null;
				this.activeTopSidebarGroup = null;
				window.cartovista.getUIController(this._map).findInstance("BbGraphs_rightPanel").activate();
			}
			//enlève le n.d dans les légendes par histogramme en overlay
			if(this._$legendViewElement.find("[id*='BarChartOverlayTheme-NAFeatures']").length || this._$legendViewElement.find("[id*='PieChartOverlayTheme-NAFeatures']").length){
				this._$legendViewElement.find("[id*='BarChartOverlayTheme-NAFeatures']").not(this._$legendViewElement.find("[id*='BarChartOverlayTheme-NAFeatures-label']")).closest(".k-item").remove();
				this._$legendViewElement.find("[id*='PieChartOverlayTheme-NAFeatures']").not(this._$legendViewElement.find("[id*='PieChartOverlayTheme-NAFeatures-label']")).closest(".k-item").remove();
			} else{
				setTimeout(function(){
				  this._$legendViewElement.find("[id*='BarChartOverlayTheme-NAFeatures']").not(this._$legendViewElement.find("[id*='BarChartOverlayTheme-NAFeatures-label']")).closest(".k-item").remove();
				  this._$legendViewElement.find("[id*='PieChartOverlayTheme-NAFeatures']").not(this._$legendViewElement.find("[id*='PieChartOverlayTheme-NAFeatures-label']")).closest(".k-item").remove();
			  }.bind(this), 1500);
			}
    	} else{
			if (this._map.activeThemeSet && this._map.activeThemeSet.id.indexOf("Provincial") > -1) {
				window.cartovista.getUIController(this._map).findInstance("btnToggleMapView").toggleOff();
			} else if(!window.cartovista.getUIController(this._map).getActiveToggledItem("responsiveBottomBarGroup")){
				window.cartovista.getUIController(this._map).findInstance("btnToggleMapView").toggleOn();
			}
		}
	}

}

$().ready(function() {
	new App(new CartovistaExtend());
});
